import { contains as a } from "../__chunks/DTR5TSDJ.js";
import { __spreadProps as d, __spreadValues as f } from "../__chunks/3YLGPPWQ.js";
function l(e) {
  return !!(e.currentTarget && !a(e.currentTarget, e.target));
}
function T(e) {
  return e.target === e.currentTarget;
}
function b(e, t) {
  const r = new FocusEvent("blur", t), n = e.dispatchEvent(r), c = d(f({}, t), { bubbles: !0 });
  return e.dispatchEvent(new FocusEvent("focusout", c)), n;
}
function g(e, t, r) {
  const n = new KeyboardEvent(t, r);
  return e.dispatchEvent(n);
}
function h(e, t) {
  const r = new MouseEvent("click", t);
  return e.dispatchEvent(r);
}
function w(e, t) {
  const r = e.currentTarget, n = e.relatedTarget;
  return !n || !a(r, n);
}
function L(e, t, r, n) {
  const u = ((i) => {
    const s = requestAnimationFrame(i);
    return () => cancelAnimationFrame(s);
  })(() => {
    e.removeEventListener(t, o, !0), r();
  }), o = () => {
    u(), r();
  };
  return e.addEventListener(t, o, { once: !0, capture: !0 }), u;
}
function v(e, t, r, n = window) {
  const c = [];
  try {
    n.document.addEventListener(e, t, r);
    for (const o of Array.from(n.frames))
      c.push(v(e, t, r, o));
  } catch {
  }
  return () => {
    try {
      n.document.removeEventListener(e, t, r);
    } catch {
    }
    for (const o of c)
      o();
  };
}
export {
  v as addGlobalEventListener,
  b as fireBlurEvent,
  h as fireClickEvent,
  g as fireKeyboardEvent,
  w as isFocusEventOutside,
  l as isPortalEvent,
  T as isSelfTarget,
  L as queueBeforeEvent
};
//# sourceMappingURL=events.js.map
